// extracted by mini-css-extract-plugin
export var capital = "blocks-module--capital--bwxru";
export var industry = "blocks-module--industry--nMoGn";
export var root = "blocks-module--root--EiSOh";
export var value = "blocks-module--value--COo48";